import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { Link } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/navigation';
const WheelLoaderProductsComponent = ({ onOpenEnquiry }) => {
  const handleModal = () => {
    if (onOpenEnquiry) {
      onOpenEnquiry();
    }
  };

  // Product data structure for better maintainability
  const products = [
    {
      id: 'gs1450',
      title: 'HW70 Wheel Loader',
      image: './images/wheelLoader/hw_70_loader_1.webp',
      logo: './images/logos/hengwang_logo.webp',
      year: '2025',
      slug: 'hw70-wheel-loader',
      badges: ['New', 'For Sale']
    },
    {
      id: 'gs1452',
      title: 'HW5T Wheel Loader',
      image: './images/wheelLoader/hw_5t_wheelLoader.webp',
      logo: './images/logos/hengwang_logo.webp',
      year: '2025',
      slug: 'hw5t-wheel-loader',
      badges: ['New', 'For Sale']
    },
    {
      id: 'gs1452',
      title: 'HW5T Wheel Loader',
      image: './images/wheelLoader/hw_5t_wheelLoader_2.webp',
      logo: './images/logos/hengwang_logo.webp',
      year: '2025',
      slug: 'hw5t-wheel-loader',
      badges: ['New', 'For Sale']
    }
  ];

  // Product Card Component for DRY principle
  const ProductCard = ({ product }) => (
    <div className="recommended-product-card">
      <Link to={`/product/${product.slug}/${product.id}`}>
      <div className="recommended-product-card__image-wrapper">
        <div className="recommended-product-card__badges">
          {product.badges?.map((badge, index) => (
            <span 
              key={index} 
              className={`recommended-product-card__badge recommended-product-card__badge--${badge.toLowerCase().replace(' ', '-')}`}
            >
              {badge}
            </span>
          ))}
        </div>
        <img
          src={product.image}
          alt={product.title}
          className="recommended-product-card__image"
          loading="lazy"
        />
      </div>
      </Link>
      
      <div className="recommended-product-card__content">
        <Link to={`/product/${product.slug}/${product.id}`}>
        <div className="recommended-product-card__header">
          <div className="recommended-product-card__info">
            <h3 className="recommended-product-card__title">{product.title}</h3>
            <div className="recommended-product-card__meta">
              <img src="/images/icons/calender_icon.png" className="recommended-product-card__icon" alt="calender" />
              <span className="recommended-product-card__year">Year: {product.year}</span>
            </div>
          </div>
          <div className="recommended-product-card__logo">
            <img src={product.logo} alt="Brand logo" />
          </div>
        </div>
        </Link>
        
        <div className="recommended-product-card__actions">
          <Link to={`/product/${product.slug}/${product.id}`}
            className="recommended-product-card__btn recommended-product-card__btn--secondary"
          >
            View Details

          </Link>
          <button
            onClick={handleModal}
            className="recommended-product-card__btn recommended-product-card__btn--primary"
          >
            Get a Quote
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <section className="recommended-products-section">
        <div className="recommended-products-container">
          <div className="recommended-products-header">
            <h2 className="recommended-products-title">
              <span className="recommended-products-title--bold">Bestselling Recommended</span> Products
            </h2>
            <div className="hidden sm:flex items-end">
              <img src="/images/logos/authorized_dealer_stamp_1.png" alt="Stamp" />
            </div>
          </div>

          {/* Mobile Slider */}
          <div className="recommended-products-mobile-slider">
            <Swiper
              modules={[Navigation, Autoplay]}
              spaceBetween={16}
              slidesPerView={1.1}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              breakpoints={{
                480: {
                  slidesPerView: 1.2,
                  spaceBetween: 20
                }
              }}
            >
              {products.map((product) => (
                <SwiperSlide key={product.id}>
                  <ProductCard product={product} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {/* Desktop Grid */}
          <div className="recommended-products-grid">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
          <div className='flex justify-center mt-4 items-center'>
            <Link to="/products?taxonomy=equipment-buy&term=wheel-loaders&termName=Wheel%20Loaders" className="font-semibold recommended-product-card__btn--secondary">View more Listing</Link>
          </div>
        </div>
      </section>
      <style jsx>{`
.recommended-products-section {
  padding: 3rem 0;
  background-color: #fafafa;
  overflow-x: hidden;
}

@media (min-width: 640px) {
  .recommended-products-section {
    padding: 4rem 0;
  }
}

.recommended-products-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
}

@media (min-width: 640px) {
  .recommended-products-container {
    padding: 0 1.5rem;
  }
}

@media (min-width: 1024px) {
  .recommended-products-container {
    padding: 0 2rem;
  }
}

/* Header Styles */
.recommended-products-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 2rem;
}

.recommended-products-header img {
  height: 100px;
  width: auto;
}

@media (min-width: 1024px) {
  .recommended-products-header {
    margin-bottom: 3rem;
  }
}

.recommended-products-title {
  font-size: 2.5rem;
  font-weight: 400;
  color: #000;
  line-height: 1.2;
}

@media (min-width: 640px) {
  .recommended-products-title {
    font-size: 1.875rem;
  }
}

@media (min-width: 1024px) {
  .recommended-products-title {
    font-size: 2.25rem;
  }
}

@media (min-width: 1280px) {
  .recommended-products-title {
    font-size: 3rem;
  }
}

.recommended-products-title--bold {
  font-weight: 700;
}

/* Mobile Slider */
.recommended-products-mobile-slider {
  display: block;
}

.recommended-products-mobile-slider .swiper {
  overflow: visible;
  padding: 1rem 0;
}

.recommended-products-mobile-slider .swiper-wrapper {
  align-items: stretch;
}

@media (min-width: 640px) {
  .recommended-products-mobile-slider {
    display: none;
  }
}

/* Desktop Grid */
.recommended-products-grid {
  display: none;
}

@media (min-width: 640px) {
  .recommended-products-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
    align-items: stretch;
  }

  .recommended-products-grid > * {
    height: 100%;
  }
}

@media (min-width: 1024px) {
  .recommended-products-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* Product Card Styles */
.recommended-product-card {
  background: #ffffff;
  border-radius: 6px;
  overflow: hidden;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
}

// .recommended-product-card:hover {
//   transform: translateY(-4px);
//   box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
// }

/* Image Wrapper */
.recommended-product-card__image-wrapper {
  position: relative;
  padding: 2rem 1.5rem;
  background: linear-gradient(159.21deg, rgba(255, 210, 0, 0.12) 11.19%, rgba(247, 151, 30, 0.12) 101.23%);
  min-height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.recommended-product-card__image {
  width: 100%;
  //max-width: 280px;
  height: 100%;
  max-height: 250px;
  object-fit: contain;
  mix-blend-mode: multiply;
}

/* Badges */
.recommended-product-card__badges {
  position: absolute;
  bottom: 1.875rem;
  left: 1.5rem;
  display: flex;
  gap: 0.5rem;
  z-index: 10;
}

.recommended-product-card__badge {
  padding: 0.25rem 0.875rem;
  border-radius: 22px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: capitalize;
  letter-spacing: 0.5px;
  display:flex;
  align-items:center;
  justify-content:center;
}

.recommended-product-card__badge--new {
  background: linear-gradient(159.21deg, #FFD200 11.19%, #F7971E 101.23%);
  //border: 2px solid rgba(0, 124, 145, 1);
  color: rgba(26, 26, 26, 1);
;
}

.recommended-product-card__badge--for-sale {
background: rgba(245, 241, 230, 0.9);
  border: 2px solid rgba(0, 124, 145, 1);
  color: rgba(26, 26, 26, 1);

}

/* Content Area */
.recommended-product-card__content {
  padding: 1.5rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
}

.recommended-product-card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.recommended-product-card__info {
  flex: 1;
}

.recommended-product-card__title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #000;
  margin: 0 0 0.5rem 0;
  line-height: 1.3;
}

.recommended-product-card__meta {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.recommended-product-card__icon {
  width: 1rem;
  height: 1rem;
}

.recommended-product-card__year {
  color: rgba(26, 26, 26, 1);
  font-size: 0.875rem;
  font-weight: 500;
}

.recommended-product-card__logo {
  width: 80px;
  height: auto;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.recommended-product-card__logo img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

/* Actions */
.recommended-product-card__actions {
  display: flex;
  gap: 0.75rem;
  margin-top: auto;
}

.recommended-product-card__btn {
  flex: 1;
  padding: 0.625rem 1rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1.125rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  text-decoration: none;
  display: inline-block;
}
.recommended-product-card__btn--primary {
background: linear-gradient(159.21deg, #FFD200 11.19%, #F7971E 101.23%);
  color: #000;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.22);
}

.recommended-product-card__btn--primary:hover {
background: linear-gradient(159.21deg, #F7971E 11.19%, #FFD200 101.23%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(247, 151, 30, 0.4);
}

.recommended-product-card__btn--secondary {
    background: linear-gradient(159.21deg, #EEC712 11.19%, #CA7710 101.23%);
    background-clip: text;
    color: transparent;
    -webkit-text-fill-color: transparent;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.recommended-product-card__btn--secondary::after {
    content: '›';
    font-size: 18px;
    transition: transform 0.2s ease;
}

.recommended-product-card__btn:active {
  transform: translateY(0);
}

/* Mobile Responsive */
@media (max-width: 480px) {
  .recommended-product-card {
    max-width: 100%;
    box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.2);
  }

  .recommended-product-card__image-wrapper {
    padding: 1.5rem 1rem;
    min-height: 180px;
  }

  .recommended-product-card__image {
    //max-width: 240px;
    max-height: 180px;
  }

  .recommended-product-card__content {
    padding: 1.25rem;
  }

  .recommended-product-card__title {
    font-size: 1rem;
  }

  .recommended-product-card__logo {
    width: 60px;
  }

  .recommended-product-card__actions {
    gap: 0.5rem;
  }

  .recommended-product-card__btn {
    font-size: 0.875rem;
    padding: 0.5rem 0.75rem;
  }
}

/* Swiper Navigation Customization */
.recommended-products-mobile-slider :global(.swiper-button-next),
.recommended-products-mobile-slider :global(.swiper-button-prev) {
  color: #f7971e;
  background: rgba(255, 255, 255, 0.9);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.recommended-products-mobile-slider :global(.swiper-button-next::after),
.recommended-products-mobile-slider :global(.swiper-button-prev::after) {
  font-size: 1.25rem;
  font-weight: bold;
}
      
      
      `}</style>
    </>
  );
};

export default WheelLoaderProductsComponent;